import { Outlet } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import { Box } from "@mui/material";
import { Colors } from "../utils/colors";


export default function AccountLayout() {

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: Colors.secondary }}>
      

      
      <Outlet />

      

    </Box>
  );
}
